<template>
  <div class="wen">
    <mynav></mynav>
    <div class="index-top">
      <img src="../assets/WenTop.jpg" alt="" width="100%" />
      <div class="banner-text">
        <h1>智慧文旅解决方案</h1>
        <p>
          智能化预约系统，引导游客错峰旅游，精准管控游客流量。“全渠道、全场景、全业态”
          预定制，实现旅游各类服务一站式预约，满足游客多样化需求，提升旅游业现代化综合
          治理水平。
        </p>
        <div>立即咨询</div>
      </div>
    </div>
    <div class="general">
      <div class="item-title">文旅平台应用</div>
      <div class="platform-content general-content">
        <div class="platform-content-left">
          <div v-for="(item, index) in platList" :key="index">
            <img src="../assets/get.png" alt="" />
            <p>
              <span>{{ item.title }}</span>
              {{ item.text }}
            </p>
          </div>
        </div>
        <div class="platform-content-right">
          <div class="platform-content-right-item">
            <div class="platform-content-right-item-top">文旅网络</div>
            <img src="../assets/add.png" alt="" width="25px" />
            <div class="platform-content-right-item-con">
              <p>网上预约</p>
              <p>文旅码</p>
            </div>
            <div class="platform-content-right-item-bottom">手机</div>
          </div>
          <div class="platform-content-right-item">
            <div class="platform-content-right-item-top">景点场所</div>
            <img src="../assets/add.png" alt="" width="25px" />
            <div class="platform-content-right-item-con">
              <p>现场核验</p>
              <p>健康码</p>
            </div>
            <div class="platform-content-right-item-bottom">数字哨兵</div>
          </div>
        </div>
      </div>
    </div>
    <div class="price">
      <div class="item-title">平台闭环和价值</div>
      <div class="price-content">
        <div class="price-content-top">
          <img src="../assets/line.png" alt="" width="100%" class="line" />
          <div class="price-content-top-item">
            <img src="../assets/priceImg-1.png" alt="" class="priceImg" />
          </div>
          <div class="price-content-top-item">
            <img src="../assets/priceImg-2.png" alt="" class="priceImg" />
          </div>
          <div class="price-content-top-item">
            <img src="../assets/priceImg-3.png" alt="" class="priceImg" />
          </div>
        </div>
        <div class="price-content-top">
          <div class="price-content-top-item">
            <div>
              <h3>快速预约</h3>
              <p><i class="el-icon-check"></i> 一键实名预约</p>
              <p><i class="el-icon-check"></i>支持购票及支付</p>
              <p><i class="el-icon-check"></i>精控导流</p>
            </div>
          </div>
          <div class="price-content-top-item">
            <div>
              <h3>一秒通行</h3>
              <p><i class="el-icon-check"></i>对接市大数据中心</p>
              <p><i class="el-icon-check"></i>多种通行方式</p>
              <p><i class="el-icon-check"></i>数字哨兵核验</p>
            </div>
          </div>
          <div class="price-content-top-item">
            <div>
              <h3>管理及营销</h3>
              <p><i class="el-icon-check"></i>大数据可视化管理</p>
              <p><i class="el-icon-check"></i>游客画像、引流吸粉</p>
              <p><i class="el-icon-check"></i>AI营销报告</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="general">
      <div class="item-title">头部客户成功案例</div>
      <div class="case-content general-content">
        <div
          class="case-content-item"
          v-for="(item, index) in caseData"
          :key="index"
        >
          <img :src="item.img1" alt="" />
          <div class="case-content-item-bottom">
            <img :src="item.img2" alt="" />
            <div>
              <h4>{{ item.name }}</h4>
              <p>{{ item.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <myfooter :type="1"></myfooter> -->
  </div>
</template>
<script>
// import myfooter from "../components/myfooter.vue";
import mynav from "../components/mynav.vue";
export default {
  data() {
    return {
      platList: [
        {
          title: "一码通行：",
          text: "打通文旅码、身份证、随申码、社保卡。",
        },
        {
          title: "一机通行：",
          text: "数字哨兵。",
        },
        {
          title: "数据共享：",
          text: "各部门数据源共享，各码自动转化。",
        },
        {
          title: "数字化管理：",
          text: "大数据管理。",
        },
      ],
      caseData: [
        {
          name: "徐汇文旅平台",
          text: "一键实名预约支持购票及支付精控导流",
          img1: require("../assets/cover1.png"),
          img2: require("../assets/coverLogo1.jpg"),
        },
        {
          name: "青浦文旅平台",
          text: "一键实名预约支持购票及支付精控导流",
          img1: require("../assets/cover2.png"),
          img2: require("../assets/coverLogo2.jpg"),
        },
      ],
    };
  },
  components: {
    // myfooter,
    mynav,
  },
};
</script>
<style lang="less" scoped>
.wen {
  .general {
    .platform-content {
      display: flex;
      justify-content: space-between;
      .platform-content-left {
        div {
          display: flex;
          align-items: center;
          font-size: 18px;
          color: #495267;
          img {
            width: 20px;
            height: 20px;
            margin-right: 5px;
          }
          p {
            margin: 10px 0;
            span {
              font-weight: 600;
            }
          }
        }
      }
      .platform-content-right {
        display: flex;
        .platform-content-right-item {
          border: 1px dashed rgb(159, 181, 197);
          padding: 20px;
          text-align: center;
          margin: 0 10px;
          border-radius: 5px;
          .platform-content-right-item-top {
            color: #495267;
            font-weight: 700;
          }
          .platform-content-right-item-con {
            width: 155px;
            padding: 8px 0;
            background-color: rgb(221, 240, 255);
            border-radius: 5px;
            color: #2659e6;
            font-weight: 700;
          }
          .platform-content-right-item-bottom {
            color: #495267;
            font-size: 12px;
            margin-top: 14px;
          }
        }
      }
    }
  }
  .price {
    padding-top: 40px;
    background-color: #f5f7f9;
    padding-bottom: 80px;
    .price-content {
      width: 692px;
      margin: 0 auto;
      .price-content-top {
        position: relative;
        display: flex;
        justify-content: space-around;
        .line {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 0;
        }
        .price-content-top-item {
          text-align: center;
          z-index: 1;
          .priceImg {
            width: 50%;
          }
          h3 {
            color: #242b43;
            margin-top: 10px;
            margin-bottom: 10px;
          }
          p {
            font-size: 12px;
            line-height: 20px;
            color: #abb0bc;
            i {
              color: #2659e6;
            }
          }
        }
      }
    }
  }

  .general {
    .case-content {
      padding-bottom: 50px;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .case-content-item {
        width: 300px;
        box-shadow: 0px 4px 14px rgba(75, 103, 136, 0.1);
        margin: 0 15px;
        img {
          width: 100%;
        }
        .case-content-item-bottom {
          display: flex;
          align-items: center;
          color: #21293e;
          padding: 10px 5px;
          box-sizing: border-box;
          img {
            width: 65px;
          }
          p {
            font-size: 10px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .wen {
    .general {
      .platform-content {
        margin-bottom: 40px;
        .platform-content-left {
          img {
            width: 10px;
            height: 10px;
            margin-right: 5px;
          }
          p {
            margin: 10px 0;
            font-size: 12px;
            span {
              font-weight: 600;
            }
          }
        }
        .platform-content-right {
          .platform-content-right-item {
            padding: 10px;
            .platform-content-right-item-con {
              width: 145px;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .wen {
    .general {
      .platform-content {
        margin-bottom: 20px;
        flex-direction: column;
        align-items: center;
        .platform-content-left {
          margin-bottom: 15px;
        }
      }
      .case-content {
        justify-content: space-between;
        .case-content-item {
          width: 48%;
          margin: 0 0 10px 0;
          .case-content-item-bottom {
            padding: 8px 3px;
            img {
              width: 40px;
            }
            h4 {
              font-size: 14px;
            }
            p {
              font-size: 10px;
            }
          }
        }
      }
    }
    .price {
      padding-top: 20px;
      padding-bottom: 40px;
      .price-content {
        width: 95%;
        margin: 0 auto;
        .price-content-top {
          .price-content-top-item {
            h3 {
              color: #242b43;
              margin-top: 10px;
              margin-bottom: 10px;
              font-size: 16px;
            }
            p {
              font-size: 10px;
              line-height: 20px;
              color: #abb0bc;
              i {
                color: #2659e6;
              }
            }
          }
        }
      }
    }
  }
}
</style>